import { Form } from "@workspace/web-ui/components/form"
import FormField from "~/features/dashboard/components/form-field/form-field"
import useNote from "../../hooks/use-note"
import { FormFieldType } from "~/features/dashboard/types"
import { Button } from "@workspace/web-ui/components/button"
import { ICD10Form } from "./icd10-form"

export type Note = {
    subjective: string,
    objective: string,
    assessment: string,
    plan: string
}

type NoteFormProps = {
    data?: Note;
    patientId: string;
    onOpenChange: (open: boolean) => void
    submitText?: string
    isEditing?: boolean
    onICD10CodeChange?: (code: string | undefined) => void
}

export const NoteForm = ({ data, onOpenChange, patientId, submitText = "Submit", isEditing, onICD10CodeChange }: NoteFormProps) => {
    const { form, handleSubmit, isLoading } = useNote({ data, patientId })

    const closeForm = () => {
        onOpenChange(false)  
    }


    return (
        <Form {...form}>
            <form onSubmit={form.handleSubmit(handleSubmit)} className="flex flex-col h-full min-h-full">
                <div className="px-6 pb-4 space-y-4 flex-1">
                    <FormField
                        control={form.control}
                        name="subjective"
                        fieldType={FormFieldType.TEXTAREA}
                        label="Subjective"
                        placeholder="E.g Patient reports no notable side effects. Sleep has improved since adjusting medication timing."
                        className="w-full border border-gray-200 rounded-md"
                    />
                    <FormField
                        control={form.control}
                        name="objective"
                        fieldType={FormFieldType.TEXTAREA}
                        label="Objective"
                        placeholder="E.g BP: 120/80 mmHg, HR: 72 bpm, Weight: 165 lbs. Lab results within normal limits."
                        className="w-full border border-gray-200 rounded-md"
                    />
                    <FormField
                        control={form.control}
                        name="assessment"
                        fieldType={FormFieldType.TEXTAREA}
                        label="Assessment"
                        placeholder="E.g Patient is responding well to current treatment. Blood pressure controlled."
                        className="w-full border border-gray-200 rounded-md"
                    />
                    <FormField
                        control={form.control}
                        name="plan"
                        fieldType={FormFieldType.TEXTAREA}
                        label="Plan"
                        placeholder="E.g Continue current medication regimen. Follow up in 4 weeks. Maintain exercise routine."
                        className="w-full border border-gray-200 rounded-md"
                    />
                </div>
                {isEditing && (
                         <div className="">
                             <ICD10Form 
                                onSubmit={() => {}} 
                                onCancel={() => onOpenChange(false)} 
                                isLoading={isLoading} 
                                isEditing={isEditing}
                                onCodeChange={onICD10CodeChange}
                             />
                         </div>
                )}

                <div className="shrink-0 flex justify-end w-full gap-2 px-6 py-4 border-t bg-white mt-auto sticky bottom-0">
                    <Button type="button" className="button-primary w-full" onClick={closeForm}>
                        Cancel
                    </Button>
                    <Button type="submit" className="!bg-[#4272DD] !border-none text-white !rounded-lg !shadow-none w-full flex items-center justify-center" disabled={isLoading}>
                        {isLoading && (
                            <svg className="animate-spin h-4 w-4 mr-2 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"></path>
                            </svg>
                        )}
                        {submitText}
                    </Button>
                </div>
            </form>
        </Form>
    )
}